<template>
<div class="common-dialog" :visible="show">
    <a-modal :visible="show" :footer="false" :hide-title="true" :width="533">
      <div>
        <div class="cd-title">
          <img class="cd-icon" src="@/assets/img/trash/wiki-cd-warn.svg">
           <Span>{{ title }}</Span>
        </div>
        <div class="cd-content">{{ content }}</div>
        <div>
          <button class="cd-cancel" @click="handleCancelSelf">{{ cancelText }}</button>
          <button class="cd-ok" @click="handleOkSelf">{{ okText }} </button>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script lang="ts">
export default {
  components: {},
  computed: {},
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    okText: {
      type: String,
      default: ''
    },
    cancelText: {
      type: String,
      default: ''
    },
    handleOk: {
      type: Function,
      default: () => {}
    },
    handleCancel: {
      type: Function,
      default: () => {}
    },
  },
  methods: {
    handleOkSelf() {
      this.handleOk()
    },
    handleCancelSelf() {
      this.handleCancel()
    }
  }
};
</script>

<style lang="scss" scoped>
.cd-icon {
    width: 24px;
    height: 24px;
    padding-right: 16px;
  }
  .cd-title {
    display: flex;
    align-content: center;
    justify-content: flex-start;
    Span {
      font-size: 16;
      color: #121317;
      font-weight: 600;
      padding-top: 2px;
    }
  }

  .cd-content {
    font-size: 14;
    color: #222329;
    font-weight: 400;
    padding-left: 40px;
    padding-top: 8px;
  }

  .cd-cancel {
    width: 76px;
    height: 36px;
    border: 1px solid #CFD3D6;
    background-color: #fff;
    color: #222329;
    border-radius: 8px;
    margin-right: 8px;
    margin-left: 325px;
    cursor: pointer;
    &:hover {
      background-color: #CFD3D6 !important;
    }
  }

  .cd-ok {
    width: 76px;
    height: 36px;
    border: 0px;
    background-color: #FF4747;
    color: #FFFFFF;
    border-radius: 8px;
    cursor: pointer;
    &:hover {
      background-color: #FF5959 !important;
    }
  }
</style>
